import { gql } from "@apollo/client";

export const QUERY_NAMESPACE = gql`
  query ($ns: String!) {
    namespaces(where: { name: { equals: $ns } }) {
      id
    }
  }
`;

export const MUTATION_CREATE_NAMESPACE = gql`
  mutation ($ns: String!) {
    createNamespace(data: { name: $ns }) {
      id
    }
  }
`;

export const QUERY_LABEL_EXISTS_IN_NAMESAPCE = gql`
  query QUERY_LABEL_EXISTS_IN_NAMESAPCE($fieldKey: String!) {
    fieldKeys(where: { fieldKey: { equals: $fieldKey } }) {
      id
    }
  }
`;

export const MUTATION_CREATE_FIELD_KEY_IN_NAMESPACE = gql`
  mutation MUTATION_CREATE_FIELD_KEY_IN_NAMESPACE(
    $fieldKey: String!
    $namespaceId: ID!
  ) {
    createFieldKey(
      data: { fieldKey: $fieldKey, namespace: { connect: { id: $namespaceId } } }
    ) {
      id
    }
  }
`;


export const QUERY_LABELS = gql`
  query QUERY_LABELS ($where: LabelWhereInput!) {
    labels(where: $where) {
      id
      value
    }
  }
`;

export const MUTATION_UPDATE_ONE_LABEL = gql`
  mutation UPDATE_ONE_LAEBL($id: ID!, $value: String!) {
    updateLabel(where: { id: $id }, data: { value: $value }) {
      id
      value
      lastModified
    }
  }
`;

export const MUTATION_CREATE_ONE_LABEL = gql`
  mutation MUTATION_CREATE_ONE_LABEL(
    $value: String!
    $fieldKey: String!
    $code: String!
  ) {
    createLabel(
      data: {
        value: $value
        fieldKey: { connect: { fieldKey: $fieldKey } }
        language: { connect: { code: $code } }
      }
    ) {
      id
      value
      lastModified
    }
  }
`;
